import { Injectable } from '@angular/core';
import { Config } from '../config';
import { ContactGroup } from '../../../model/contact-group';
import { HttpClient } from '@angular/common/http';
import { StorageService } from '../../managers/storage.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ContactGroupService extends Config {

  constructor(private httpClient: HttpClient,
    private storageService: StorageService) {
    super();
  }

  public createContactGroup(contactGroup: ContactGroup[]) : Observable<any> {
    var url;

    url = "contact_group_create";

    return this.httpClient.post(this.BASE_URL + url, contactGroup, this.storageService.getHeaders());
  }
}
